import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: 'start', pathMatch: 'full' },
  {
    path: 'start',
    loadChildren: './start/start.module#StartPageModule'
  },
  {
    path: 'start/:step',
    loadChildren: './start/start.module#StartPageModule'
  },
  {
    path: 'home',
    loadChildren: './start/start.module#StartPageModule'
  },
  {
    path: 'leaderboard',
    loadChildren: './leaderboard/leaderboard.module#LeaderboardPageModule'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
